import { z } from 'zod';

import { studentsPageResponseSchema, type StudentsResponse } from '@/features/performance-dashboard/schemas/student';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export const getStudentsParamsSchema = z.object({
  redeId: z.string().optional(),
  escolaId: z.number().optional(),
  serieId: z.number().optional(),
  turmaId: z.number().optional(),
  alunoAtivo: z.boolean().optional(),
  anoLetivo: z.number().optional(),
  search: z.string().optional(),
});

export type GetStudentsParams = z.infer<typeof getStudentsParamsSchema>;

export const getStudents = httpGetAdapter<StudentsResponse, GetStudentsParams>({
  url: '/v3/dashboard/resultado/alunos',
  schema: studentsPageResponseSchema,
  mapParams: (params) => ({
    ...(params?.redeId ? { redeId: params.redeId } : {}),
    ...(params?.escolaId ? { escolaId: params.escolaId } : {}),
    ...(params?.serieId ? { serieId: params.serieId } : {}),
    ...(params?.turmaId ? { turmaId: params.turmaId } : {}),
    ...(params?.alunoAtivo !== undefined ? { alunoAtivo: params.alunoAtivo } : {}),
    ...(params?.anoLetivo ? { anoLetivo: params.anoLetivo } : {}),
    ...(params?.search ? { search: params.search } : {}),
  }),
});
